import {
  Component, OnInit, ViewChild, ViewEncapsulation, Input
} from '@angular/core';
import { FormGroup, FormControl, NgForm, AbstractControl, NgModel } from '@angular/forms';
import { AuditStdImport, Property } from '../../../rate-audit/ra-create/utilities/auditstd-import-model';
import { GridComponent, GridDataResult, DataStateChangeEvent,PageChangeEvent,RowClassArgs } from '@progress/kendo-angular-grid';
import { State } from '@progress/kendo-data-query';
import { CreateReverseAudit } from '../../../../core/models/CreateReverseAudit'
import { CreateFromStandardAudit } from '../../../../core/models/CreateFromStandardAudit-model';

import { dynamicSort } from '../../../../core/dynamic-sort';

@Component({
selector: 'app-rvrs-create-step2',
templateUrl: './rvrs-create-step2.component.html',
styleUrls: ['./rvrs-create-step2.component.scss']
})
export class RvrsCreateStep2Component implements OnInit {

  dataToSave:CreateReverseAudit= new CreateReverseAudit();
  importData:CreateFromStandardAudit=new CreateFromStandardAudit();

  public includeChainCodes:string = "include";
  public visibleChainCodeList:Array<string> = [];
  public hiddenChainCodeList:Array<string> = null;
  public newChainCode:string = '';
  public gridView:GridDataResult;
  public allPropertiesChecked:boolean = true;
  public state: State = {

    group: [],
    skip: 0,
    take: 5
  };
  public sorted: string = "";
  public numberSortedFields = ['PropertyPostalCode'];

  constructor() {
  }

  ngOnInit() {
  }

  updateData(importData:CreateFromStandardAudit,dataToSave:CreateReverseAudit) {
    this.dataToSave = dataToSave;
    this.importData=importData;
    this.clearAllChainCodes();
    if(this.dataToSave && importData.Properties) {
      let property = importData.Properties;
      this.gridView=this.pagination(this.state,property);

      for(let ctr=0; ctr<property.length; ctr++) {
        let p = property[ctr];
        p.IsChecked = true;
      }
        this.hiddenChainCodeList = [];
        let hiddenChainCodeList = this.hiddenChainCodeList;
        for(let ctr=0; ctr<property.length; ctr++) {

          let p = property[ctr];

        if(p.AmadeusChainCode!=""){
          if(hiddenChainCodeList.indexOf(p.AmadeusChainCode)==-1){
            hiddenChainCodeList.push(p.AmadeusChainCode);
            }
        }
        if(p.ApolloChainCode!=""){
          if(hiddenChainCodeList.indexOf(p.ApolloChainCode)==-1){
            hiddenChainCodeList.push(p.ApolloChainCode);
          }
        }
        if(p.GalileoChainCode!=""){
          if(hiddenChainCodeList.indexOf(p.GalileoChainCode)==-1){
            hiddenChainCodeList.push(p.GalileoChainCode);
          }
        }
        if(p.SabreChainCode!=""){
          if(hiddenChainCodeList.indexOf(p.SabreChainCode)==-1){
            hiddenChainCodeList.push(p.SabreChainCode);
          }
        }
        if(p.WorldspanChainCode!=""){
          if(hiddenChainCodeList.indexOf(p.WorldspanChainCode)==-1){
            hiddenChainCodeList.push(p.WorldspanChainCode);
          }
        }
        hiddenChainCodeList = hiddenChainCodeList.sort();
      }
    }
  }

  addAllChainCodes() {
    this.visibleChainCodeList = [];
    for(let code of this.hiddenChainCodeList) {
      this.visibleChainCodeList.push(code);
    }
  }

  clearAllChainCodes() {
    this.visibleChainCodeList = [];
  }
  UpdateIncludeExcludeChainCodes(){
    this.dataToSave.IncludeExcludeChainCodes
      = this.visibleChainCodeList.length==0?
        null:
        (((this.includeChainCodes=="include")?"I:":"E:") + this.visibleChainCodeList.join(",") );
  }
  addChainCode(event) {
    if(this.newChainCode && this.importData && this.importData.Properties) {
      this.newChainCode = this.newChainCode.trim().toUpperCase();
      //ensure no special characters, and ensure a max length of 3
      this.newChainCode = this.newChainCode
        .replace(/[^A-Z0-9,]/g, '')
        .replace(/(^|,)(\w\w\w)\w*/g, '$1$2');
      let newChainCodeList = this.newChainCode.split(',');
      for(let chainCode of newChainCodeList) {
        if(chainCode!='') {
          if(this.visibleChainCodeList.indexOf(chainCode)==-1) {
            this.visibleChainCodeList.push(chainCode);
          }
          if(this.hiddenChainCodeList.indexOf(chainCode)==-1) {
            this.hiddenChainCodeList.push(chainCode);
          }
        }
      }
    }
  }

  removeChainCodeFromVisibleList(chainCode){
    let index = this.visibleChainCodeList.indexOf(chainCode);
    this.visibleChainCodeList.splice(index, 1);
  }

  allPropertiesClicked(event) {
    let property = this.importData.Properties;

    for(let ctr=0; ctr<property.length; ctr++) {
      property[ctr].IsChecked = this.allPropertiesChecked;
    }
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    let data= this.importData.Properties;
    this.sorted = "";
    this.sorted = (state.sort.find(e =>  e.dir==='asc' ||e.dir=='desc' ) || {'field':''}).field;
    //check the field name against the list of field names to be sorted as numbers, then pass sort type to dynamicSort
    var sort = state.sort[0];
    if(sort!=undefined){
      let propertyDataType;
      if(this.numberSortedFields.indexOf(sort.field)>-1) {
        propertyDataType = 'number';
      }
      var sortFn = dynamicSort(sort.field, sort.dir, propertyDataType);
      data.sort(sortFn);
    }
    this.gridView =  this.pagination(this.state, this.importData.Properties);
  }

  pagination(state: any, data:any){
    let subsetSorted = data.slice(state.skip, state.skip + state.take);
    return ({
      data: subsetSorted,
      total: data.length
    });
  }

}
